import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-blog-section',
  templateUrl: './create-blog-section.component.html',
  styleUrls: ['./create-blog-section.component.scss']
})
export class CreateBlogSectionComponent implements OnInit, AfterViewInit {
  @Input() sectionInfo: any;
  blogSectionForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit(): void {
    if (this.sectionInfo.sectionId) {
      this.updateForm();
    }
  }


  sendData(): any {
    let dataToSend;
    if (this.sectionInfo.sectionId) {
      dataToSend = {
        ...this.blogSectionForm.value,
        orderId: this.sectionInfo.index,
        id: this.sectionInfo.sectionId
      };
    } else {
      dataToSend = {
        ...this.blogSectionForm.value,
        orderId: this.sectionInfo.blog.length + 1,
      };
    }


    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.blogSectionForm = this.fb.group({
      name: ['', Validators.required]
    });
  }

  private updateForm(): any {
    this.blogSectionForm.get('name').setValue(this.sectionInfo.section);
  }

}
